// What each movement type means, and which ones a given item can take.
//
// The dropdown used to offer all five for every item, so a consumable that is
// neither sellable nor rentable still offered "Sale" and "Rental out" — the
// office had no way to tell which of them applied to what.

import type { InventoryItem, InventoryMovementType } from './types';

/** rental_return is absent on purpose: returns are recorded from the Rentals tab. */
export const ALL_MOVEMENT_TYPES: InventoryMovementType[] = ['purchase', 'sale', 'give', 'rental_out', 'adjustment'];

/**
 * The movement types that make sense for `item`.
 *
 * Purchase, give and adjustment apply to anything you hold stock of. Sale needs
 * the item to be sellable and rental_out needs it to be rentable — those two
 * are what post a client charge, so offering them for an item nobody priced is
 * how you end up billing a client for a box of gloves at €0.
 */
export const movementTypesForItem = (item: InventoryItem | null): InventoryMovementType[] =>
  ALL_MOVEMENT_TYPES.filter((type) => {
    if (type === 'sale') return Boolean(item?.isSellable);
    if (type === 'rental_out') return Boolean(item?.isRentable);
    return true;
  });

/** Signed effect on stock. Mirrors `stock_delta` in the backend's inventory/validation.py. */
export const stockSign = (type: InventoryMovementType, adjustmentSign: number | null): number => {
  if (type === 'adjustment') return adjustmentSign ?? 0;
  if (type === 'purchase') return 1;
  if (type === 'sale' || type === 'give' || type === 'rental_out') return -1;
  return 0;
};
